export default __webpack_public_path__ + "static/media/Vanguard.29c53aef.svg";